import React, { createContext, useContext, ReactNode } from 'react';

export enum OnboardingStep {
  BusinessSettings = 'BusinessSettings',
  Roles = 'Roles',
  Users = 'Users',
  AppointmentTypes = 'AppointmentTypes',
  Calendar = 'Calendar',
  Completed = 'Completed'
}

interface OnboardingContextType {
  isOnboarding: boolean;
  currentStep: OnboardingStep;
  nextStep: () => void;
  completeOnboarding: () => void;
  skipOnboarding: () => void;
  isAdminUser: boolean;
}

const OnboardingContext = createContext<OnboardingContextType | undefined>(undefined);

export const useOnboarding = () => {
  const context = useContext(OnboardingContext);
  if (!context) {
    throw new Error('useOnboarding must be used within an OnboardingProvider');
  }
  return context;
};

interface OnboardingProviderProps {
  children: ReactNode;
}

// Onboarding is temporarily disabled - no API calls are made.
// The provider still exists so consuming components don't break.
export const OnboardingProvider: React.FC<OnboardingProviderProps> = ({ children }) => {
  return (
    <OnboardingContext.Provider value={{
      isOnboarding: false,
      currentStep: OnboardingStep.Completed,
      nextStep: () => {},
      completeOnboarding: () => {},
      skipOnboarding: () => {},
      isAdminUser: false
    }}>
      {children}
    </OnboardingContext.Provider>
  );
};
